import { IAssessment } from 'interfaces/assessments';
import { getAPI } from 'requests/api';

export const ASSESSMENT_ATTEMPT_MAP = new Map([
  ['unknown', 'Desconhecida'],
  ['started', 'Iniciada'],
  ['evaluation_started', 'Em correção'],
  ['completed', 'Finalizada'],
  ['pending', 'Aguardando correção'],
  ['evaluated', 'Corrigida'],
  ['passed', 'Aprovada'],
  ['failed', 'Reprovada'],
  ['scored', 'Nota calculada'],
  ['corrected', 'Corrigida']
]);

// Os status que uma tentativa de avaliação (`Assessments::Attempt`) tem no atlas. O mapa acima
// também traduz os de atividade, que não servem de filtro aqui.
export const ASSESSMENT_ATTEMPT_STATUS_OPTIONS = [
  'pending',
  'completed',
  'evaluation_started',
  'corrected',
  'scored',
  'passed',
  'failed'
].map(status => ({
  value: status,
  label: ASSESSMENT_ATTEMPT_MAP.get(status) ?? status
}));

export const ASSESSMENT_KIND_MAP: Record<IAssessment['kind'], string> = {
  objective: 'Objetiva',
  discursive: 'Discursiva',
  mixed: 'Mista'
};

export const ASSESSMENT_KIND_OPTIONS: {
  label: string;
  value: IAssessment['kind'];
}[] = [
  { label: 'Objetiva', value: 'objective' },
  { label: 'Discursiva', value: 'discursive' },
  { label: 'Mista', value: 'mixed' }
];

export const translateAssessmentAttemptStatus = (status: string) => {
  return ASSESSMENT_ATTEMPT_MAP.get(status);
};

export const fetchAssessmentsAttemptsLogs = async (attemptId: string) => {
  const { data } = await getAPI().get(
    `/admin/assessments/attempts/${attemptId}/logs`
  );

  return data;
};
